import { Component, Inject } from '@angular/core';

import { FormMessage } from '../../../../shared/form-messages/form-message.model';
import { PaymentMethod } from '../../../../../services/billing/payment-method.model';
import { UserSettingsService } from '../../../../../services/members/user-settings.service';
import { Organization } from '../../../../../models/entities/organization';
import { GrowlerService } from '../../../../../services/growler.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export interface AutopayActivatorDialogInput
{
    organization: Organization;
}

export interface AutopayActivatorDialogOutput
{
    data: any; // todo - define this where it comes from the back end etc
}

@UntilDestroy()
@Component({
    selector: 'lf-autopay-activator',
    styleUrls: ['./autopay-activator.scss'],
    templateUrl: './autopay-activator.component.html',
})
export class AutopayActivatorComponent
{
    paymentMethod: PaymentMethod = null;
    autopayMax = 0;
    hasAgreedTerms = false;
    hasCheckedAgreement = true;
    isViewingTerms = true;
    isGuardingDoubleSubmission = false;

    formMessage: FormMessage = <FormMessage>{};

    constructor(
            private _dialogRef: MatDialogRef<AutopayActivatorComponent>,
            private _userSettingsService: UserSettingsService,
            private _growlerService: GrowlerService,
            @Inject(MAT_DIALOG_DATA) public data: AutopayActivatorDialogInput,
    ) {
    }

    get isSaveButtonDisabled(): boolean {
        return this.isGuardingDoubleSubmission || !(this.autopayMax > 0) || !this.paymentMethod
                || this.paymentMethod.value === 'new-bank-account' || this.paymentMethod.value === 'new-credit-card';
    }

    paymentMethodChanged($event: any) {
        this.paymentMethod = $event;
    }

    saveAutopaySettings() {
        // error checks first
        if (!(this.paymentMethod &&
                (this.paymentMethod.type.indexOf('CreditCard') !== -1 ||
                        this.paymentMethod.type.indexOf('PaymentBankAccount') !== -1))) {
            this._growlerService.error(
                    'Error',
                    'Please select a payment type.',
            );
            return;
        }

        if (!(this.autopayMax && this.autopayMax > 0)) {
            this._growlerService.error(
                    'Error',
                    'Please enter an auto pay max amount.',
            );
            return;
        }

        this._userSettingsService.enableAutopaySettings(null, this.data.organization.id, {
            paymentMethodType: this.paymentMethod.type,
            paymentMethodId: this.paymentMethod.value.id,
            autopayMax: this.autopayMax,
        })
                .pipe(untilDestroyed(this))
                .subscribe(
                        (data: any) => {
                            this._growlerService.success(
                                    'Success',
                                    `Autopay has been enabled for ${this.data.organization.name}.`,
                            );

                            this._dialogRef.close(<AutopayActivatorDialogOutput>{data: data});
                        },
                        () => {
                            this.formMessage.type = 'failure';
                            this.formMessage.message = 'We were unable to enable your autopay settings.';
                        },
                );
    }

    proceedIfAgree() {
        this.isViewingTerms = false;

        if (this.hasCheckedAgreement) {
            this.hasAgreedTerms = true;
        } else {
            this._growlerService.error(
                    'Error',
                    'The agreement checkbox is required for autopay.',
            );
        }
    }
}
